<template lang="pug">
  app-page(title="Тестовое распределение" :loading="loadingNewCase")
    app-toolbar(title="Тестовое распределение")
      v-btn(@click.native="dialog.period = true") Очистить распределение

    v-layout(align-start)
      v-flex(xs7 sud-block-overlay)
        .sud-block-title Список номеров дел для распределения
        v-simple-table.mb-10(fixed-header height="400px")
          template(v-slot:default)
            thead
              tr
                th id 
                th № Дела
                th Кат-ия
                th Кол-во томов
                th С присяжными
                th Несовершеннолетние
            tbody
              tr(v-for="c in distribNew" :key="c.id")
                td 
                  v-checkbox(@change="setDistrib(c)" )
                td {{ c.number }}
                td {{ c.caseCategory ? c.caseCategory.gasCategoryUid : c.mainLawArticle ? 'Уг.' : '-' }}
                td {{ c.numberBook }}
                td {{ isBoolean(c.hasJuri) }}
                td {{ isBoolean(c.hasYoung) }}

        .sud-block-title Список номеров дел для распределения
        v-container(fluid)
          v-textarea(v-model="list" label="Номера дел" outlined)
        v-btn(@click.native="distribCase") Распределить

      v-flex(xs5 sud-block-overlay)
        .sud-block-title Статистика распределения на сегодня ({{ countDistribution() }})
        v-simple-table(fixed-header)
          template(v-slot:default)
            thead
              tr
                th ФИО
                th Распределено сегодня
                th Всего дел (с начала года)
                th Вес дел (с начала года)

            tbody
              tr(v-for="s in stat" :key="s.id")
                td 
                  a(:href="'/admin/judges/' + s.id" target="_blank" style="color: white;") {{ s.lastName }}
                td {{ s.count }}
                td {{ s.fullcount }}
                td {{ s.weightcount }}
        v-btn.mt-5(@click.native="openStatistica") Стастистика категория-судья

    app-dialog(v-model="dialog.period" header="Выбрать период" confirm-text="Очистить" @confirm="clearDistrib")
      app-date-picker(v-model="startPeriod" viewFormat="DD.MM.YYYY" format="YYYY-MM-DD")
      app-date-picker(v-model="endPeriod" viewFormat="DD.MM.YYYY" format="YYYY-MM-DD")

    app-dialog(v-model="dialog.empty" header="Уведомление")
      | Не найдено ни одного дела с такими номерами: {{ numbersNotList.join(",") }}

    app-dialog-loading(v-model="loading")
</template>

<script>
import { distribService } from "@/_services";
import { mapGetters, mapMutations } from 'vuex'
import { AppDialogConfirm, AppDialogLoading } from '@/components'

import moment from 'moment'
moment.locale('ru')

export default {
  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    [AppDialogLoading.name]: AppDialogLoading,
  },

  data () {
    return {
      startPeriod: moment().format('YYYY-MM-DD'),
      endPeriod: moment().format('YYYY-MM-DD'),

      list: '',
      listDistrib: [],
      stat: [],
      listIds: [],
      numbersNotList: [],
      loading: false,
      dialog: {
        period: false,
        empty: false
      }
    }
  },

  mounted () {
    this.statJudgeFullCount ()
    this.$store.commit('setInDistribution', true)
    this.$store.dispatch('distribution/LOAD_NEW')
  },

  computed: {
    ...mapGetters('distribution', ['distribNew', 'isDistribNew']),

    loadingNewCase () {
      return !this.isDistribNew
    }
  },

  methods: {
    ...mapMutations('distribution', ['filterDistribNew', 'setDistribNew']),

    countDistribution () {
      let count = 0
      this.stat.map(item => {
        count += item.count
      })
      return count
    },

    distribCase () {
      this.loading = true

      let listNumbers = ''
      this.list.split(/\n/).map(item => { 
        if (item.indexOf(",") != -1) listNumbers += item
        else listNumbers += item + ","
      })
      this.list = listNumbers.replace(/\s{2,}/g, '')
      
      this.listDistrib = this.distribNew
      if (this.list.indexOf("")!=-1 && this.list != null) {
        let listIds = []
        this.numbersNotList = []
        let arr = this.list.split(",").map(item => { return item.trim() })
        
        arr.map(number => {
          if (number) {
            let distribCase = this.listDistrib.filter(item => number.indexOf(item.number) != -1)
            if (distribCase.length > 0) listIds.push(distribCase[0].id)
            else 
              if (!this.numbersNotList.includes(number)) this.numbersNotList.push(number)
          }
        })
        if (this.numbersNotList.length > 0) this.dialog.empty = true

        if (listIds.length > 0) {
          let obj = { "caseIds": "" + listIds.join(",") }
          distribService.distributionCase(obj).then(() => this.statJudgeFullCount(listIds))
        } else {
          this.dialog.empty = true
          this.loading = false
        }
      } else 
        distribService.distributionCase({}).then(() => this.statJudgeFullCount())
    },

    statJudgeFullCount (listIds) {
      if (listIds !== undefined) this.filterDistribNew(listIds)
      else distribService.newListCase().then(data => this.setDistribNew(data))
      
      let today = moment().format('YYYY-MM-DD')
      distribService.getStatJudgeFullcount(today, today).then(data => {
        this.stat = data
        this.list = ''
        this.loading = false
      })
    },

    clearDistrib () {
      this.loading = true
      distribService.clearDistrib(this.startPeriod, this.endPeriod).then(() => this.statJudgeFullCount())
    },

    openStatistica () {
      let routeData = this.$router.resolve({ path: `/admin/statistic` });
      window.open(routeData.href, '_blank');
    },

    setDistrib (courtCase) {
      if (this.listIds.includes(courtCase.id)) this.listIds = this.listIds.filter( item => item != courtCase.id)
      else this.listIds.push(courtCase.id)

      let listNumbers = []
      this.distribNew.map(item => {
        if (this.listIds.includes(item.id)) listNumbers.push(item.number)
      })
      this.list = listNumbers.join(",\n")
    },

    isBoolean (boo) {
      return boo ? 'Да' : 'Нет'
    }
  }
  
}
</script>

<style scoped>

</style>